import SimpleBarMantis from 'mantis/components/third-party/SimpleBar';

const SimpleBar = (props) => {
	return <SimpleBarMantis {...props} />;
};

export default SimpleBar;
